import { Component, OnInit } from "@angular/core";

import { ApiService } from "../../services/api.service";

@Component({
  selector: "app-blog",
  templateUrl: "./blog.component.html",
  styleUrls: ["./blog.component.scss"]
})
export class BlogComponent implements OnInit {
  public blogList: any[];
  public totalPages = 1;
  public page = 1;
  constructor(private _api: ApiService) {}

  ngOnInit() {
    this.getBlogs();
  }

  getBlogs() {
    this._api.getBlog({ pageid: this.page }).subscribe(
      res => {
        this.blogList = res.data;
        this.totalPages = res.total_pages;
      },
      err => {
        console.log(err);
      }
    );
  }
}
